module.exports = __webpack_public_path__ + "64f37b55c2cc4ca473689248356a41fc.svg";